export const SpaceSortTypeService = Symbol('SpaceSortTypeService');
